import { CardConfiguration } from './card-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';

declare var moment: any;

export class ExamSessionCardConfiguration extends CardConfiguration {
    constructor(course: any) {
        super();
        // console.log(course);
        let hoursSinceRelease=moment.duration(moment().diff(moment(course.releaseDate, "YYYY.MM.DD HH:mm").toDate())).asHours();
        this.tagType = 'examSession';
        this.classType = (hoursSinceRelease <= 72 && !course.expired) ? 'New Exam Session' : 'Exam Session';
        this.thumbnail = course.virtualVenue ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/classroom-class.png':
        'https://itpx-branded-portal-dev.s3.amazonaws.com/online-class.png';
        this.expired = course.expired;
        this.action = LinkActions.REDIRECT;
        this.clickable = true;
        this.target = ['/app','exam', course.id];
        this.links = [{
            disabled: false,
            tooltip: null,
            url: this.target,
            type: LinkActions.REDIRECT,
            text: 'branded.portal.courses.examsession.material.text'
        }];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/exam-session-card-configuration.ts